module.exports = __webpack_public_path__ + "static/media/upgrades_selected.222ac87a.svg";